import {
  FETCH_USER_REQUEST,
  FETCH_USER_SUCCESS,
  FETCH_USER_FAILURE,
  UPDATE_USER_REQUEST,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAILURE,
  RESET_USER_DETAILS,
} from '../ProfileUpdate/profileUpdateTypes';

export const fetchUserRequest = (userId) => ({
  type: FETCH_USER_REQUEST,
  payload: userId,
});

export const fetchUserSuccess = (user) => ({
  type: FETCH_USER_SUCCESS,
  payload: user,
});

export const fetchUserFailure = (error) => ({
  type: FETCH_USER_FAILURE,
  payload: error,
});

export const updateUserRequest = (payload) => ({
  type: UPDATE_USER_REQUEST,
  payload,
});

export const updateUserSuccess = (message) => ({
  type: UPDATE_USER_SUCCESS,
  payload: message,
});

export const updateUserFailure = (error) => ({
  type: UPDATE_USER_FAILURE,
  payload: error,
});
export const resetUserDetails = () => ({
  type: RESET_USER_DETAILS,
});
